<script setup lang="ts">
import { ref,reactive,onMounted,onBeforeUnmount,toRefs,watch } from 'vue'
import CustomList from "../../compositions/CustomList.vue";
import ModalDialog from "../../compositions/ModalDialog.vue";
import config from "../../config.js";
import { errorAlert,confirmAlert } from "../../plugins/alert";
import { initialOrderPackData,initialOrderData } from "../../plugins/order";
import { getFieldValue,configKeyFromValue,deepCopy } from "../../plugins/utility";
import qs from 'qs';
import { useOrderStore } from '../../stores/order';
import axios from '../../plugins/axios.ts';

const order = useOrderStore();

const props = defineProps({
    apis:{
      type:Object,
      required:true,
    },
    identityId:{
      type:Number,
      required:true,
    },
    submit:{
      type:Function,
    },
    cancel:{
      type:Function,
    },
});
const { identityId } = toRefs(props);
const listChartRef = ref();
const isLoading = ref(false);
const cartCheckList = reactive([]);
const onChangeCartCheckList = (values) => {
  cartCheckList.splice(0);
  for (let i=0;i<values.length;i++) {
    cartCheckList.push(values[i]);
  }
}
const chartFields = reactive([
  {field_name: '採用品名', field_key: 'product_detail_name', width: '15%', align: 'text-left', sorted:true},
  {field_name: '種類', field_key: 'stock_type', width: '5%', align: 'text-center', sorted:true},
  {field_name: '取引先', field_key: 'target_name', width: '10%', align: 'text-left', sorted:false},
  {field_name: '数量', field_key: 'number', width: '5%', align: 'text-center', sorted:false},
  {field_name: '登録者', field_key: 'creator_name', width: '10%', align: 'text-right', sorted:false},
]);
const optionChartFields = reactive({
  'page_size' : 30,
});
const listSearch = () => {
  if (typeof listChartRef.value === 'undefined') {
    return;
  }
  listChartRef.value.resetItem();
}
watch(identityId,(newValue,oldValue) => {
  listSearch();
});
onMounted(() => {
})
onBeforeUnmount(() => {
})
const takeCartMedicineConfirm = async () => {
  if (cartCheckList.length == 0) {
    errorAlert('採用品を選択してください。');
    return;
  }
  let result = await confirmAlert('現在の発注予約情報を取り込みますか？<br><span class="text-red-500">※一覧への反映にはタイムラグがある場合があります。</span>');
  if (result.isConfirmed) {
    await takeCartMedicine();
  }
}

const takeCartMedicine = async () => {
  if (cartCheckList.length == 0) {
    errorAlert('採用品を選択してください。');
    return;
  }
  //ローカルにデータを保存する
  for (let i=0;i<cartCheckList.length;i++) {
    let item = listChartRef.value.getItemById(cartCheckList[i]);
    if (item.stock_type == config.STOCK_TYPES['小分け']) {
      let index = order.search_data_index('is_auto_pack',item.pharmacy_medicine_id,'pharmacy_medicine_id',{pharmacy_id:item.pharmacy.id,medicine_group_id:item.medicine_group_id});
      if (index != -1) {
          order.edit_order_pack_data[index].tax_total_type = item.tax_total_type;
          order.edit_order_pack_data[index].amount_float_type = item.amount_float_type;
          order.edit_order_pack_data[index].assignment_date = item.assignment_date;
          order.edit_order_pack_data[index].to_pharmacy_note = item.to_pharmacy_note;
          order.edit_order_pack_data[index].number = item.number;
          order.edit_order_pack_data[index].unit_price = item.unit_price;
      } else {
        let record = initialOrderPackData(null,item);
        record.pharmacy_medicine_id = item.pharmacy_medicine_id;
        order.save_data('is_auto_pack',record,'pharmacy_medicine_id',{pharmacy_id:item.pharmacy.id,medicine_group_id:item.medicine_group_id});
      }
    } else {
      let index = order.search_data_index('is_auto',item.pharmacy_medicine_id);
      if (index != -1) {
          order.edit_order_data[index].wholesaler_id = item.wholesaler_id;
          order.edit_order_data[index].wholesaler_old_id = item.wholesaler_old_id;
          order.edit_order_data[index].wholesaler_name = item.wholesaler_name;
          order.edit_order_data[index].order_status = item.order_status;
          order.edit_order_data[index].lot_number = item.lot_number;
          order.edit_order_data[index].commited = true;
      } else {
        let record = initialOrderData(null,item);
        record.pharmacy_medicine_id = item.pharmacy_medicine_id;
        record.commited = true;
        order.save_data('is_auto',record);
      }
    }
  }
  await deleteCartMedicine(1)
}
const deleteCartMedicineConfirm = async () => {
  if (cartCheckList.length == 0) {
    errorAlert('採用品を選択してください。');
    return;
  }
  let result = await confirmAlert('本当に削除しますか？');
  if (result.isConfirmed) {
    await deleteCartMedicine();
  }
}
const deleteCartMedicine = async (isTake=0) => {
  let params = {
    ids:[],
    is_take:isTake
  };
  for (let i=0;i<cartCheckList.length;i++) {
    params.ids.push(cartCheckList[i]);
  }
  isLoading.value = true;
  try {
    const response = await axios(props.apis.pharmacy_medicine_cart_delete,{method:"post",data:params});
    if (response.data.status == 200) {
      cartCheckList.splice(0);
      if (typeof props.submit !== 'undefined') {
        props.submit(response.data.data);
      }
    }
  } finally {
    isLoading.value = false;
  }
}
const cancelCart = () => {
  if (typeof props.cancel !== 'undefined') {
    props.cancel();
  }
}
</script>

<style scoped>
</style>
<template>
<div>
  <div v-show="isLoading" class="loading-mask">
    <div class="loading-content">
      <span style="color: white"><img src="../../../public/images/loading.gif"></span>
    </div>
  </div>
  <div class="w-full">
    <custom-list
      ref="listChartRef"
      :table-fields="chartFields"
      :option-fields="optionChartFields"
      :api-url="apis.pharmacy_medicine_cart_list"
      :is-checkable="true"
      :check-values="cartCheckList"
      :on-check-change="onChangeCartCheckList"
      height="72vh"
    >
    <template v-slot:item="slotProps">
      <td v-for="(field,index) in chartFields" :style="'width:' + field.width" :class="field.align">
        <div v-if="field.field_key == 'stock_type'" :class="field.align">
          {{ configKeyFromValue(config.STOCK_TYPES,slotProps.item.stock_type) }}
        </div>
        <div v-else-if="field.field_key == 'number'" :class="field.align">
          {{ (slotProps.item.stock_type == config.STOCK_TYPES['VAN'] ? slotProps.item.lot_number : slotProps.item.number + slotProps.item.medicine.package_unit) }}
        </div>
        <div v-else-if="field.field_key == 'target_name'" :class="field.align">
          {{ (slotProps.item.stock_type == config.STOCK_TYPES['VAN'] ? slotProps.item.wholesaler.wholesaler_name : slotProps.item.pharmacy.pharmacy_name) }}
        </div>
        <div v-else-if="field.field_key == 'creator_name'" :class="field.align">
          {{ (slotProps.item.creator ? slotProps.item.creator.username : '') }}
        </div>
        <div v-else :class="field.align">
          {{ getFieldValue(slotProps.item,field.field_key) }}
        </div>
      </td>
    </template>
    </custom-list>
  </div>
  <div class="flex">
    <div class="flex-row mr-2">
      <button type="button" @click="takeCartMedicineConfirm" class="w-full py-2.5 px-5 mr-2 my-2 text-sm font-medium text-white focus:outline-none bg-amber-500 rounded-full border border-gray-200 hover:bg-amber-300 hover:text-black focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">反映する</button>
    </div>
    <div class="flex-row mr-2">
      <button type="button" @click="deleteCartMedicineConfirm" class="w-full py-2.5 px-5 mr-2 my-2 text-sm font-medium text-white focus:outline-none bg-red-700 rounded-full border border-gray-200 hover:bg-red-600 hover:text-black focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-red-600 dark:hover:text-white dark:hover:bg-red-700">削除する</button>
    </div>
    <div class="flex-row mr-2">
      <button type="button" @click="cancelCart" class="w-full py-2.5 px-5 mr-2 my-2 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-full border border-gray-200 hover:text-black focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">閉じる</button>
    </div>
  </div>
</div>
</template>

